<div
  class="release-wrapper"
  id="HeaderReleaseNoteBtn"
  (click)="onLatestReleaseClick()"
  matTooltip="{{ 'DCP_RELEASE.TOOLTIP' | translate }}"
  matTooltipPosition="right"
>
  <i class="fa fa-bullhorn"></i>
  <span *ngIf="hasNewRelease" class="badge-dot"></span>
</div>
